import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';

import { ModalComponent } from 'componets/common';
import { FormItem, SubmitButton, TextField } from 'componets/form';

import { FieldData, ModalProps } from 'models';

import { Rules } from 'utils/constants';

import { AccountService } from 'api';

interface Props extends ModalProps {
	onSetPromoCode: Dispatch<SetStateAction<string>>;
}

export const PrimaryMarketProjectPromoCodeModal: FC<Props> = ({
	isOpen,
	onClose,
	onSetPromoCode,
}) => {
	const { t } = useTranslation();

	const [form] = Form.useForm();

	const [fields, setFields] = useState<FieldData[]>([]);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const onCloseModal = () => {
		onClose();
		setFields([{ name: ['code'], value: '' }]);
	};

	const onFinish = (values: { code: string }) => {
		setIsSubmitting(true);
		AccountService.getAvailableCoupon(values)
			.then(() => {
				onSetPromoCode(values.code);

				onCloseModal();
			})
			.catch((e: { response: { data: any } }) => {
				const error = e?.response.data;

				if (error.message) {
					setFields([{ name: 'code', errors: [t(error.message)] }]);
				}
			})
			.finally(() => setIsSubmitting(false));
	};

	return (
		<ModalComponent isOpen={isOpen} onClose={onCloseModal} title={t('enterPromoCodeText')}>
			<div className="modal-content">
				<Form onFinish={onFinish} onFieldsChange={setFields} fields={fields} form={form}>
					<FormItem name="code" rules={[Rules.REQUIRED]}>
						<TextField label={t('promoCodeText')} />
					</FormItem>
					<div className="modal-footer">
						<SubmitButton text={t('applyText')} loading={isSubmitting} />
					</div>
				</Form>
			</div>
		</ModalComponent>
	);
};
